import { League } from "./League";
import { IMatch } from "../../typings/typings";

export class Match implements IMatch {
    public headers;
    public id: number;
    public beginAt;
    public calculatedAt;
    public leagueId;
    public maps;
    public parameters;
    public round;
    public group: number;
    public position: number;
    public type;
    public contestants;
    public gameaccounts;
    public status;
    public result;

    public opponent;
    public me;
    public uri: string;
    public self;

    public user;
    public league: League;
    public contestant;

    constructor(jsonData, user, league, contestant) {
        this.headers = jsonData;
        this.id = jsonData.id;
        this.beginAt = jsonData.beginAt;
        this.calculatedAt = jsonData.calculatedAt;
        this.contestants = jsonData.contestants;
        this.gameaccounts = jsonData.gameaccounts;
        this.leagueId = jsonData.leagueId;
        this.maps = jsonData.maps;
        this.parameters = jsonData.parameters;
        this.result = jsonData.result;
        this.round = jsonData.round;
        this.group = jsonData.group;
        this.position = jsonData.position;
        this.status = jsonData.status;
        this.type = jsonData.type;

        this.user = user;
        this.league = league;
        this.contestant = contestant;

        this.me = this.getContestant(this.getContestantIndex().me);
        this.opponent = this.getContestant(this.getContestantIndex().opponent);
        this.uri = this.league.getUri() + "match/" + this.id + "/";
    }

    public getUri() {
        return this.uri;
    }

    public userHasOpponent() {
        return this.opponent.id !== null;
    }

    public setResult(matchResult) {
        this.opponent.resultConfirmed = matchResult.contestants.opponent.resultConfirmed;
        this.me.resultConfirmed = matchResult.contestants.self.resultConfirmed;
    }

    public setSetup(matchSetup) {
        this.opponent.matchSetup = matchSetup.opponent;
        this.me.matchSetup = matchSetup.self;
    }

    public hasMatchPoints() {
        return this.result !== null && this.result.points[this.me.id] !== null;
    }

    public getMatchPoints() {
        return this.result.points[this.me.id];
    }

    public getOpponent() {
        return this.opponent;
    }

    public getContestantIndex() {
        const result = { me: 1, opponent: 0 };
        const contestantId = this.contestant.id;

        if (this.league.isTeamLeague()) {
            if (+this.contestants[0].team.id === +contestantId) {
                result.opponent = 1;
                result.me = 0;
            }
        } else {
            if (+this.contestants[0].user.id === +contestantId) {
                result.opponent = 1;
                result.me = 0;
            }
        }
        return result;
    }

    public getContestant(contestantIndex) {
        let result = {
            name: "",
            uri: "",
            gameaccount: "",
        };

        if (this.league.isTeamLeague()) {
            result = this.contestants[contestantIndex].team;
            result.name = this.contestants[contestantIndex].team.name;

            if (this.contestants[contestantIndex].team.suffix) {
                result.name += "." + this.contestants[contestantIndex].team.suffix;
            }

            result.uri = "/team/" + this.contestants[contestantIndex].team.alias;
        } else {
            result = this.contestants[contestantIndex].user;
            result.name = this.contestants[contestantIndex].user.nickname;
            result.uri = "/player/" + this.contestants[contestantIndex].user.alias;
            if (typeof this.gameaccounts[this.contestants[contestantIndex].user.id] !== "undefined") {
                result.gameaccount = this.gameaccounts[this.contestants[contestantIndex].user.id];
            }
        }
        return result;
    }

    public myResult() {
        if (this.status === "protest") {
            return "protest";
        }
        if (!this.opponent.id) {
            if (this.status === "closed") {
                return "win";
            }
            return "";
        }
        if (this.result.score[this.me.id] === this.result.score[this.opponent.id]) {
            return "draw";
        } else if (this.result.score[this.me.id] > this.result.score[this.opponent.id]) {
            return "win";
        } else {
            return "loss";
        }
    }

    public getConfirmStatus() {
        if (this.opponent.resultConfirmed && this.me.resultConfirmed) {
            return 3;
        }
        if (this.opponent.resultConfirmed && !this.me.resultConfirmed) {
            return 2;
        }
        if (!this.opponent.resultConfirmed && this.me.resultConfirmed) {
            return 1;
        }
        return 0;
    }

    public getCancelStatus() {
        if (
            typeof this.opponent.matchSetup !== "undefined" &&
            typeof this.opponent.matchSetup.cancel !== "undefined" &&
            this.opponent.matchSetup.cancel.confirmed === true
        ) {
            return 2;
        }
        if (
            typeof this.me.matchSetup !== "undefined" &&
            typeof this.me.matchSetup.cancel !== "undefined" &&
            this.me.matchSetup.cancel.confirmed === true
        ) {
            return 1;
        }
        return 0;
    }

    public getMoveStatus() {
        if (
            typeof this.opponent.matchSetup !== "undefined" &&
            typeof this.opponent.matchSetup.move !== "undefined" &&
            this.opponent.matchSetup.move.confirmed === true
        ) {
            return 2;
        }
        if (
            typeof this.me.matchSetup !== "undefined" &&
            typeof this.me.matchSetup.move !== "undefined" &&
            this.me.matchSetup.move.confirmed === true
        ) {
            return 1;
        }
        return 0;
    }

    public isConfirmed() {
        return this.getConfirmStatus() == 3;
    }

    public waitingForMeConfirm() {
        return this.getConfirmStatus() == 2;
    }

    public waitingForOpponentConfirm() {
        return this.getConfirmStatus() == 1;
    }

    public noneConfirmed() {
        return this.getConfirmStatus() === 0;
    }

    public isProtest() {
        return this.status === "protest";
    }
}
